import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const settingsActionsKeys = {
    container: generateAutomationName("settings", ["actions", "container"]),
    cancel: generateAutomationName("settings", ["button", "cancel"]),
    save: generateAutomationName("settings", ["button", "save"]),
};
